import { Box, Breadcrumbs, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { ReactComponent as TrashIcon } from "assets/icons/Bredcrum_Icon/infoIcon.svg";
import { ReactComponent as ActiveLogIcon } from "assets/icons/CatalogueCard/active_log.svg";
import { ReactComponent as DisableSparkleIcon } from "assets/icons/Sparkel_Disable.svg";
import { ReactComponent as SparkleIcon } from "assets/icons/Sparkle.svg";
import SeparatorIcon from "components/Icons/SeparatorIcon";
import { useCatalogSettingContext } from "context/CatalogSettingContext";
import { useGlobalContext } from "context/GlobalContext";
import SortContext from "context/SortContext";
import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { capitalEachLetter } from "utils/capitalEachLetter";
import { isChanges } from "utils/checkExitCatalogUpdate";
import OrderClientDetailsComp from "./OrderClientDetails/OrderClientDetailsComp";
import { findSpecificMenu, findSpecificSubMenu, isAllowed } from "utils/checkUserRigths";
import { usePermissions } from "context/PermissionsContext";
import { useDispatch } from "react-redux";
import { setCatalogListScrollTargetId } from "store/cartSlice";

function formatDateDdMmYyyy(value) {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  const dd = String(date.getDate()).padStart(2, "0");
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const yyyy = date.getFullYear();
  return `${dd}-${mm}-${yyyy}`;
}

const BreadCrumbComponent = ({ breadcrumbs, onBreadcrumbClick }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { id: routeId, collectionName: collectionNameParam } = useParams();
  const permission = usePermissions();
  const hasAccessVieCatalogActivity = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Miscellaneous Catalog"), "catalog_activity");
  const { clientDetailsComp, showActivityLogo } = useGlobalContext();
  const {
    isArchive,
    setCheckCatalogBeforeNavigate,
    newNameCatalog,
    isInfoBtn,
    setInfoModalOpen,
    filterChangeCount,
    displayCount,
    breadCrumbLock,
    filterChangeDesignCount,
    searchResultCount,
    searchSuffix,
    setCheckedItems,
    setSelectedStartDate,
    setSelectedEndDate,
    appliedStartDate,
    setAppliedStartDate,
    appliedEndDate,
    setAppliedEndDate,
  } = useGlobalContext();

  const decodedCollectionName = collectionNameParam ? decodeURIComponent(collectionNameParam) : "";
  const aiBinnysSelectDesign = location.state?.isSelectDesign;
  const aiNewDesigns = location.state?.newDesigns;
  const nameLen = location.state?.name?.length;
  const showAppliedAiDateRange =
    location.pathname.startsWith("/Collection") &&
    appliedStartDate &&
    appliedEndDate &&
    (nameLen !== 0) &&
    ((aiBinnysSelectDesign && decodedCollectionName === "Binny's Select Designs") || (aiNewDesigns && decodedCollectionName === "New Designs"));

  const handleClearAppliedAiDates = () => {
    const today = new Date();
    setSelectedStartDate(today);
    setSelectedEndDate(null);
    setAppliedStartDate(today);
    setAppliedEndDate(null);
  };
  const { search } = React.useContext(SortContext);
  const { serarch } = useCatalogSettingContext();

  const hideSeparator = location.pathname.includes("reorder-stock-view");

  const handleOpenActivity = () => {
    let catalogId = location?.pathname?.split("/")[2];

    const state = {
      name: [`${location.state.name[0]}`, `Activity`],
      isActivity: true,
    };
    navigate(`/Catalog/${catalogId}`, { state });
  };
  const handleClick = (breadcrumb) => {
    const pathnames = breadcrumb.path.split("/").filter((x) => x);

    const rememberCatalogScrollTargetIfLeavingDetail = () => {
      if (pathnames[0] !== "Catalog" || pathnames.length !== 1) return;
      if (!routeId) return;
      dispatch(setCatalogListScrollTargetId(routeId));
    };

    if (breadcrumb.name === "Set") {
      onBreadcrumbClick(breadcrumb);
    }
    if (pathnames[0] === "Catalog" && location?.state?.catalogueName) {
      const value = isChanges(location?.state?.catalogueName, newNameCatalog, isArchive);

      if (value) {
        setCheckCatalogBeforeNavigate(value);
      } else {
        let state = { ...location.state, name: [breadcrumb.name], subName: "" };

        const isEdit = !!state?.edit || !!state?.isCatalogReport;

        switch (pathnames[0]) {
          case "Catalog": {
            if (pathnames.length === 1) {
              state.view = false;
              state.edit = false;
              state.isActivity = false;
              state.cataloguUpdate = false;
              rememberCatalogScrollTargetIfLeavingDetail();
            } else if (pathnames.length === 2 && isEdit) {
              state.edit = false;
              state.view = false;
              state.cataloguUpdate = false;
            } else if (pathnames.length === 2) {
              state.edit = false;
              state.view = true;
            } else {
              state.subName = "Edit";
            }
            break;
          }
          case "Stock": {
            if (pathnames.length >= 2) {
              state.name = [capitalEachLetter(pathnames[1]), breadcrumb.name];
            }
            // Add your Client Activity navigation logic here for Stocks
            if (breadcrumb.name === "Client Activity" || breadcrumb.name === "Client-Activity") {
              const id = pathnames[1] || location?.state?.id;
              const catalogClientId = location?.state?.catalogClientId;
              const companyName = location?.state?.companyName;

              const path = companyName
                ? `/CatalogSetting/Client-Activity/${id}/${catalogClientId}?companyName=${encodeURIComponent(companyName)}`
                : `/CatalogSetting/Client-Activity/${id}/${catalogClientId}`;
              navigate(path, { ...location });
              return;
            }
            break;
          }
          default: {
            break;
          }
        }
        sessionStorage?.removeItem("checkedItems");
        setCheckedItems([]);
        navigate(breadcrumb.path, { state });
      }
    } else {
      const { isSession, isClientReport, ...cleanState } = location.state || {};
      let state = { ...cleanState, name: [breadcrumb.name], subName: "" };

      switch (pathnames[0]) {
        case "Catalog": {
          if (pathnames.length === 1) {
            state.view = false;
            state.edit = false;
            state.isActivity = false;
            rememberCatalogScrollTargetIfLeavingDetail();
          } else if (pathnames.length === 2 && !location.state?.innerCahnges) {
            state.edit = false;
            state.view = false;
            state.isActivity = false;
          } else if (pathnames.length === 2) {
            state.edit = false;
            state.view = true;
          } else {
            state.subName = "Edit";
          }
          break;
        }
        case "Collection": {
          if (pathnames.length >= 2) {
            state.name = [decodeURIComponent(pathnames[1]), breadcrumb.name];
          }
          if (breadcrumb.name === "Collection") {
            state.aiIcon = false;
          } else {
            state.aiIcon = location.state?.aiIcon || window.history.state?.aiIcon || false;
          }
          break;
        }
        case "Stock": {
          if (pathnames.length >= 2) {
            state.name = [capitalEachLetter(pathnames[1]), breadcrumb.name];
          }
          if (breadcrumb.name === "Client Activity" || breadcrumb.name === "Client-Activity") {
            const id = pathnames[1] || location?.state?.id;
            const catalogClientId = location?.state?.catalogClientId;
            const companyName = location?.state?.companyName;

            const path = companyName
              ? `/CatalogSetting/Client-Activity/${id}/${catalogClientId}?companyName=${encodeURIComponent(companyName)}`
              : `/CatalogSetting/Client-Activity/${id}/${catalogClientId}`;
            navigate(path, { ...location });
            return;
          }
          break;
        }
        default: {
          break;
        }
      }

      navigate(breadcrumb.path, { state });
    }
  };

  return (
    <>
      <Breadcrumbs aria-label="breadcrumb" separator={hideSeparator ? null : <SeparatorIcon />}>
        {breadcrumbs.map((breadcrumb, index) => (
          <span key={index}>
            {index === breadcrumbs.length - 1 ? (
              <Typography
                color="textPrimary"
                sx={{
                  fontFamily: "Poppins, sans-serif",
                  fontWeight: "400",
                  fontSize: "24px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: clientDetailsComp ? "32px" : "10px",

                  cursor: "default",
                }}
              >
                {index === 1 && location.state?.aiIcon && <SparkleIcon />}
                {/* {breadcrumb.name} */}
                {/* {breadcrumb.name} {displayCount && `${filterChangeCount ? ` - ${filterChangeCount} ${filterChangeDesignCount > 0 ? `(${filterChangeDesignCount})`  : ""}` : ""}`} {displayCount && `${searchResultCount && (search || serarch) ? ` (Search results: ${searchResultCount})` : ""}`} */}
                {/* {displayCount && `${searchResultCount && (search || serarch) ? ` (Search results: ${searchResultCount})` : ""}`} */}
                {breadcrumb.name} {displayCount && <>{filterChangeCount > 0 && ` - ${filterChangeCount}${filterChangeDesignCount > 0 ? ` (${filterChangeDesignCount} ${searchSuffix})` : " "}`}</>}
                {isInfoBtn && (
                  <IconButton sx={{ p: 0, ml: 0.7 }} onClick={() => setInfoModalOpen(true)} disableRipple disableFocusRipple>
                    <TrashIcon />
                  </IconButton>
                )}
                {showActivityLogo && hasAccessVieCatalogActivity && (
                  <IconButton sx={{ p: 0, ml: 0.7 }} onClick={() => handleOpenActivity()} disableRipple disableFocusRipple>
                    <ActiveLogIcon />
                  </IconButton>
                )}
                {searchResultCount > 0 && (search || serarch) && ` (Search results: ${searchResultCount})`}
                {clientDetailsComp && <OrderClientDetailsComp />}

                {showAppliedAiDateRange && (
                  <Box
                    component="span"
                    className="child-header-applied-date-pill"
                    sx={{
                      display: "inline-flex",
                      alignItems: "center",
                      alignSelf: "center",
                      gap: "3px",
                      ml: 0.5,
                      px: "6px",
                      py: "2px",
                      border: "1px solid rgba(255,255,255,0.9)",
                      borderRadius: "3px",
                      color: "#fff",
                      whiteSpace: "nowrap",
                      textDecoration: "none",
                      boxSizing: "border-box",
                    }}
                  >
                    <Box
                      component="span"
                      sx={{
                        m: 0,
                        p: 0,
                        textDecoration: "none",
                      }}
                    >
                      {formatDateDdMmYyyy(appliedStartDate)}
                      {" to "}
                      {formatDateDdMmYyyy(appliedEndDate)}
                    </Box>
                    <IconButton
                      type="button"
                      size="small"
                      aria-label="Clear date range"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleClearAppliedAiDates();
                      }}
                      disableRipple
                      disableFocusRipple
                      sx={{
                        p: 0,
                        m: 0,
                        ml: "1px",
                        minWidth: "16px",
                        width: "16px",
                        height: "16px",
                        borderRadius: "2px",
                        color: "#fff",
                        textDecoration: "none",
                        "&:hover": { backgroundColor: "rgba(255,255,255,0.12)" },
                      }}
                    >
                      <CloseIcon sx={{ fontSize: 12, display: "block" }} />
                    </IconButton>
                  </Box>
                )}
              </Typography>
            ) : (
              <Typography
                color="textPrimary"
                sx={{
                  fontFamily: "Poppins, sans-serif",
                  fontWeight: "400",
                  fontSize: "24px",
                  color: "inherit",
                  // cursor: "pointer"
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "10px",

                  cursor: (index === 0 && breadCrumbLock) || location?.state?.isEditCatagory ? "default" : "pointer",
                }}
                // onClick={location?.state?.isEditCatagory || breadCrumbLock ? null : () => handleClick(breadcrumb, index)}
                onClick={index === 0 && breadCrumbLock ? null : location?.state?.isEditCatagory ? null : () => handleClick(breadcrumb, index)}
              >
                {index === 1 && location.state?.aiIcon && <DisableSparkleIcon />}
                {breadcrumb.name}
              </Typography>
            )}
          </span>
        ))}
      </Breadcrumbs>
    </>
  );
};

export default BreadCrumbComponent;
